import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Sessions } from 'src/app/libraries/sessions';
import { IReturn } from 'src/app/libraries/ireturn';
import { APP_BASE_HREF } from '@angular/common';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CotizacionesCondicionesTiposService {

  constructor(private http: HttpClient,  @Inject(APP_BASE_HREF) private baseUrl: string) { }

  dataSource(varArgs : any = null): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Cotizaciones/Condiciones/Tipos/DataSource", varArgs, Sessions.header());
  }

  store(objCotizacionCondicionTipo : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Cotizaciones/Condiciones/Tipos/Store", objCotizacionCondicionTipo, Sessions.header());
  }

  update(objCotizacionCondicionTipo : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Cotizaciones/Condiciones/Tipos/Update", objCotizacionCondicionTipo, Sessions.header());
  }

  delete(objCotizacionCondicionTipo : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Cotizaciones/Condiciones/Tipos/Delete", objCotizacionCondicionTipo, Sessions.header());
  }

}